/**
 * Allows access to first value of map, by an actual key of the map
 *
 * This avoids need for Object.values(map) which creates an array of values of the object which is then thrown away
 */
function firstValue(map) {
    for (const key in map) {
        // Ensure key is actually present on object, not inherited from prototype chain (if map happended to be non-pojo)
        if (!Object.prototype.hasOwnProperty.call(map, key)) {
            continue;
        }
        return map[key];
    }
}
/**
 * Finds value in map matching predicate - convenient alternative to Object.values + array.find
 * @param map
 * @param predicate
 * @returns
 */
function findValue(map, predicate) {
    for (const key in map) {
        // Ensure key is actually present on object, not inherited from prototype chain (if map happended to be non-pojo)
        if (!Object.prototype.hasOwnProperty.call(map, key)) {
            continue;
        }
        const value = map[key];
        if (value !== undefined && predicate(value)) {
            return value;
        }
    }
}
/**
 * Checks if the provided map is empty.
 *
 * This provides an alternate way to determine if a map of records is empty. It avoids need for Object.keys(map) - which
 * creates an array object to determine emptiness.
 *
 * See benchmark here: https://silentmantra.github.io/benchmark#H4sIAAAAAAAAE2WQwYqDMBRFf%2BUiXURQ29lWLJ3FrPsBzdBG%2BxxTY1KeKYyI%2Fz5EOx3KbB6Px%2BGem4xR5S4UbSNDHitD9ss3KPC2yaWtnO09FDMKvDOrIavZdWJcqO0vPiUQpwQ6RrGDjrNO3YQOuzie29Wop3MC%2FRnHz0RXXlHgUF6p8nPkh%2FWsqReKOVDSrtfYl2SrplPcghSbIaVv7VPj3C3tyDfuIu0oLRB6M%2FV341GgVqanPJxrx2KxnaBtUMaYefzRnu8LDJRMqp33KYwFyaWd%2Frdxc%2B%2B0paF%2FbbLonumP9wVOBH32%2BNwdNvmrI5p%2BAJCVyHmGAQAA
 * @param map
 * @returns
 */
function isEmpty(map) {
    for (const _ in map) {
        return false;
    }
    return true;
}
/**
 * Returns number of entries in records
 *
 * Provides an efficient way to count entries without creating an array (which is what happens when calling Object.keys(..))
 *
 * See benchmark here: https://silentmantra.github.io/benchmark#H4sIAAAAAAAAE2WQQW7CMBBFr%2FIVsbBFEtotUap2wZoD1BU4YWhMEhtN3AWKfPfKMUVC3Vhj%2Ben%2FN56z1p0o22YDeawGst%2B%2BQ43Xl0rZ1tnJQzOjxgezvpVndqOYE7X9w0MOcchhJOo3GFmO%2BipMnMXnsV%2FNJhxzmC8pH4muuaDGvrlQ65fInfVsaBKaOVLKbjZ4b8i23ai5h%2FHE2lMxOHctRvKdOyk7KwtEaabpZ%2FCoEZWBs2ORag4wNnZJLCzu5HpdpWvDpPtlDvFIr5Wy4b%2BBW1yLnm7Ts0Bqeijcd4qciM1l%2BqHqOT8Lvw57jmh2AQAA
 * @param map
 * @returns
 */
function count(map) {
    let count = 0;
    for (const _ in map) {
        count++;
    }
    return count;
}
/**
 * Iterates values of a record. Skips undefined values.
 *
 * Provides a faster way to access and iterate record values compared to using Object.values().
 *
 * See benchmark here: https://silentmantra.github.io/benchmark#H4sIAAAAAAAAE5WSTW7CMBCFrzKNWNgFAd0SuWoXrHsAgsBJxo1JMkaOUymKcvfKMaGqQP3xxpbfvHmfR%2B6jzOQYbaIKHcwqpHdXgICndZxQZqhxIK0FAa%2FWym6prKlZH6o2U%2FmwAHZYgOYgnkHzZS3PTPsz2x3LWa%2BH4wL0nvNrR5OeQMBbesLMjS235KzGhklrfVVCqqXMaUOPoB1a6ZDV8syhTwhAGctCnxI70ARfEkAQPmTVIgiv7Ers9nEQtWJBeRACWspRacL86vWr01jlwX8xDX4bEho812oFLylSVtTSlhc2YxMaO%2FgJWmzayoGA9Wj%2FznvwtNODTHri1%2Bhgm8%2FjS9h0E9%2FNNWFyI2Xz93CjppkH528I%2F8JYKmO3Mit%2BxrnNn3yMjd%2FnLgyPb3Gi4ROAVb7qugIAAA%3D%3D
 */
function* iterate(map) {
    for (const key in map) {
        const value = map[key];
        if (value !== undefined) {
            yield value;
        }
    }
}
export const Records = {
    firstValue,
    findValue,
    isEmpty,
    count,
    iterate,
};
//# sourceMappingURL=records.js.map